import React, { ReactNode } from 'react';

interface Props {
    children: string | ReactNode;
}

const CentralSwitchHeader = ({ children }: Props) => (
    <header className="flex items-center justify-between px-6 py-5 text-2xl/6 font-bold">
        {children}
    </header>
);

export default CentralSwitchHeader;
